import {createSlice} from '@reduxjs/toolkit'
import * as AppConfig from '../app/config/constants'
import {state_patcher} from "./base";

function get_token_from_stores(){
    return AppConfig.SIGN_IN_USER_AUTH_TOKEN || localStorage.getItem("token") || sessionStorage.getItem("token") || null
}

function get_user_data_from_env(){
    const user_data_str = AppConfig.SIGN_IN_USER_DATA || null
    if (user_data_str) {
        return JSON.parse(user_data_str)
    }
    return null
}

export const user_state = createSlice({
    name: 'user',
    initialState: {
        user_data: get_user_data_from_env(),
        auth_token: get_token_from_stores(),
    },
    reducers: {
        update_user_state: state_patcher
    }
})

export const {
    update_user_state,
} = user_state.actions

export default user_state.reducer
